// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isCampaignsForUcoResult = objectOf({
  campaigns: arrayOf(objectOf({ id: string, name: string, composition_mode: string })),
});
